import { useState } from "react"
import { useRefresh } from "lib/@hooks/useRefresh"
import { Bound } from "lib/@components/binding/Bound"
import { DialogContent, DialogTitle, Stack, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import { RHFUploadSingleFile } from "minimals-template/components/hook-form"
import { OkCancel } from "lib/@components/okCancel"
import { parentTreeItem } from "library/tree/index.mjs"

export function RenameDialog({ currentName, currentImage, type = "Group", title = "Rename", parentItem }) {
    const [name, setName] = useState(currentName)
    const [data] = useState({ image: currentImage })
    const refresh = useRefresh()
    const regimesList = parentItem[parentTreeItem]?.children
    const isRegimeLabelDuplicate =
        normalizeName(name) !== normalizeName(currentName) &&
        regimesList.some((regime) => normalizeName(regime.label) === normalizeName(name))
    const errorMsg = isRegimeLabelDuplicate ? `There is already an item named: '${name}'. Please try again` : ""

    return (
        <Bound target={data} refresh={refresh}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Stack spacing={1} sx={{ mt: 2 }}>
                    <TextField
                        autoFocus
                        fullWidth
                        sx={{ mt: 2 }}
                        placeholder={`${type} name...`}
                        variant="outlined"
                        value={name}
                        onChange={setFromEvent(setName)}
                        label={`${type} Name`}
                        error={isRegimeLabelDuplicate}
                        helperText={errorMsg}
                        data-cy="rename-dialog-name"
                    />
                    <RHFUploadSingleFile refresh={refresh} name="image" />
                </Stack>
            </DialogContent>
            <OkCancel
                value={{ name, image: data?.image }}
                okDisabled={() => {
                    const nameUnchanged = name === currentName
                    const imageUnchanged = data?.image === currentImage
                    return !name?.trim() || isRegimeLabelDuplicate || (nameUnchanged && imageUnchanged)
                }}
            />
        </Bound>
    )

    function normalizeName(value) {
        return value?.trim()?.toLowerCase()
    }
}
